import { Components, Theme, ThemeOptions } from '@mui/material/styles';

const getTypographyTheme = (theme: Theme): ThemeOptions => {
  const typographyTheme: Components<Theme>['MuiTypography'] = {
    styleOverrides: {
      root: {
        // Default to M3 body.large
        ...theme.typography.M3.body.large,
      },
    },
  };

  return { components: { MuiTypography: typographyTheme } };
};

export default getTypographyTheme;
